var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showWatermark)?_c('div',{staticClass:"env-watermark"},[_vm._v(" "+_vm._s(_vm.watermarkMessage)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }